import * as api from "Api";
import * as actions from "Actions";

export const fetchIndicatorsExplanation = target => {
  return (dispatch, getState) => {
    let targetUen = target;
    if (getState().auth.currentOrganization) {
      const { uen } = getState().auth.currentOrganization;
      targetUen = uen;
    }

    const { token } = getState().auth;

    dispatch(
      actions.fetchIndicatorsExplanation(
        api
          .getIndicatorsExplanation({ uen: targetUen, token: token })
          .then(res => {
            return res.data.data;
          })
      )
    );
  };
};

export const saveIndicatorsExplanation = (
  explanationId,
  selectedAccount,
  contents
) => (dispatch, getState) => {
  const {
    auth: { currentOrganization }
  } = getState();
  return dispatch(
    actions.saveIndicatorExplanation(
      api.saveIndicatorsExplanation({
        owner: currentOrganization.uen,
        indicatorExplanationId: explanationId,
        selectedAccount,
        contents
      })
    )
  );
};

export const deleteIndicatorExplanation = explanationId => (
  dispatch,
  getState
) => {
  const {
    auth: { currentOrganization }
  } = getState();
  return dispatch(
    actions.deleteIndicatorExplanation(
      api.deleteIndicatorExplanation({
        owner: currentOrganization.uen,
        id: explanationId
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/indicatorsExplanation.js